import { Box, HStack, usePropsResolution } from 'native-base';
import React, { memo, forwardRef } from 'react';
import type { IChipProps } from './Chip.types';

const Chip = (
  {
    children,
    startIcon,
    endIcon,

    ...props
  }: IChipProps,
  ref: any
) => {
  const { _icon, _text, ...newProps } = usePropsResolution('Chip', props);

  if (endIcon && React.isValidElement(endIcon)) {
    endIcon = React.Children.map(
      endIcon,
      (child: JSX.Element, index: number) => {
        return React.cloneElement(child, {
          key: `chip-end-icon-${index}`,
          ..._icon,
          ...child.props,
        });
      }
    );
  }
  if (startIcon && React.isValidElement(startIcon)) {
    startIcon = React.Children.map(
      startIcon,
      (child: JSX.Element, index: number) => {
        return React.cloneElement(child, {
          key: `chip-start-icon-${index}`,
          ..._icon,
          ...child.props,
        });
      }
    );
  }

  return (
    <HStack {...newProps} ref={ref}>
      {startIcon ? startIcon : null}
      <Box _text={_text}>{children}</Box>
      {endIcon ? endIcon : null}
    </HStack>
  );
};

export default memo(forwardRef(Chip));
